import { FormRevisionService as OvermapFormRevisionService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class FormRevisionService extends OvermapFormRevisionService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
